const DEFAULT_BADGE_STATUS = "new";

const STATUS_TO_BADGE = {
  QUEUED: "info",
  IN_QUEUE: "info",
  PROCESSING: "info",
  PENDING: "info",
  FAILED: "critical",
  MISSING_INFO: "warning",
  SUCCESS: "success",
  SYNCED: "success",
  ACTIVE: "success",
  INACTIVE: "new",
};

export const mapStoreStatusToBadgeStatus = (status) => {
  if (!status) {
    return DEFAULT_BADGE_STATUS;
  }

  return STATUS_TO_BADGE[status] || DEFAULT_BADGE_STATUS;
};
